// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BYsYkZdkwKELPIxT2lvO {
    padding: 24px;
    min-height: 500px;
    min-width: 500px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    border-style: solid;
    border-color: var(--background);
    border-width: 4px;
    background-color: white;
    overflow: auto;
}

.EaAKP88E9IMT0mcjtRBW{
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
    box-sizing: border-box;
    margin-top: 24px;
    padding: 8px;
}

.idPquWMVWH65DzoD8Jbp{
    font-size: 20px;
    font-weight: 700;
    line-height: 20px;
    margin: 0px 0px 16px 0px;
}

.nOfgcGq4bTmlTugVXyEO{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 800px;
    margin: 0px;
}

.neo3hsfkMp3QctarlNIm{
    font-size: 18px;
    font-weight: 700;
    line-height: 18px;
    margin: 0px;
}

.SwVMvvrSwbu8IUqM1zmz{
    background-color: var(--background-regular);
    color: var(--letter-dark);
}

.SwVMvvrSwbu8IUqM1zmz:hover{
    background-color: var(--background-hovered-button);
}

.SwVMvvrSwbu8IUqM1zmz:active{
    background-color: var(--background-hovered-button);
}`, "",{"version":3,"sources":["webpack://./clientRoot/Static/WorkingArea/ServiceOrderManagement/ProviderQuoteDetails/ProviderQuoteDetails.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,+BAA+B;IAC/B,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,2CAA2C;IAC3C,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,kDAAkD;AACtD","sourcesContent":[".providerQuoteDetailsPopup {\n    padding: 24px;\n    min-height: 500px;\n    min-width: 500px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    height: 80%;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    border-style: solid;\n    border-color: var(--background);\n    border-width: 4px;\n    background-color: white;\n    overflow: auto;\n}\n\n.quotesBox{\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    align-items: flex-start;\n    box-sizing: border-box;\n    margin-top: 24px;\n    padding: 8px;\n}\n\n.modalTitle{\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 20px;\n    margin: 0px 0px 16px 0px;\n}\n\n.providerManagementButtons{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 800px;\n    margin: 0px;\n}\n\n.boxTitle{\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 18px;\n    margin: 0px;\n}\n\n.closeButton{\n    background-color: var(--background-regular);\n    color: var(--letter-dark);\n}\n\n.closeButton:hover{\n    background-color: var(--background-hovered-button);\n}\n\n.closeButton:active{\n    background-color: var(--background-hovered-button);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"providerQuoteDetailsPopup": `BYsYkZdkwKELPIxT2lvO`,
	"quotesBox": `EaAKP88E9IMT0mcjtRBW`,
	"modalTitle": `idPquWMVWH65DzoD8Jbp`,
	"providerManagementButtons": `nOfgcGq4bTmlTugVXyEO`,
	"boxTitle": `neo3hsfkMp3QctarlNIm`,
	"closeButton": `SwVMvvrSwbu8IUqM1zmz`
};
export default ___CSS_LOADER_EXPORT___;
